var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoLogin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 191,
    height: 54,
    viewBox: "0 0 191 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.4796 14.5873H65.1033L71.1373 31.9832L77.4435 14.5873H84.0672L73.9501 39.4581H67.9615L58.4796 14.5873Z",
    fill: "#262262"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M106.479 29.4463H90.1919C90.1919 32.7987 92.914 34.4749 98.4036 34.4749C100.899 34.4749 103.439 34.2483 105.935 33.75V38.7332C103.757 39.1863 100.899 39.4581 97.4508 39.4581C88.4226 39.4581 83.8857 35.1997 83.8857 26.7282C83.8857 18.6192 88.0142 14.5873 96.3166 14.5873C104.574 14.5873 107.931 19.5252 106.479 29.4463ZM90.1919 24.8708H100.581C100.808 21.292 99.1295 19.5252 95.5907 19.5252C92.2789 19.4799 90.4641 21.292 90.1919 24.8708Z",
    fill: "#262262"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M109.882 39.4581V14.5873H114.736L115.507 17.7584C117.685 15.6292 119.999 14.5873 122.449 14.5873V19.6611C120.09 19.6611 118.003 20.703 116.143 22.8322V39.5034H109.882V39.4581Z",
    fill: "#262262"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M131.795 5.57214V10.5554H125.488V5.57214H131.795ZM131.795 14.5872V39.458H125.488V14.5872H131.795Z",
    fill: "#262262"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M158.789 31.7115C158.789 26.5923 162.418 24.0554 169.586 24.0554C171.764 24.0554 173.669 24.1913 175.393 24.5084V22.8776C175.393 20.6578 173.216 19.5252 168.906 19.5252C166.184 19.5252 163.462 19.9329 160.785 20.7031V15.7198C163.462 14.9497 166.184 14.542 168.906 14.542C177.435 14.542 181.654 17.2601 181.654 22.7417V39.4128H178.478L175.756 37.646C173.579 38.8239 171.265 39.4128 168.815 39.4128C162.146 39.4581 158.789 36.8759 158.789 31.7115ZM169.632 28.7668C166.592 28.7668 165.095 29.7182 165.095 31.6209C165.095 33.5235 166.365 34.4749 168.906 34.4749C171.446 34.4749 173.624 33.8407 175.439 32.5269V29.2651C173.805 28.948 171.9 28.7668 169.632 28.7668Z",
    fill: "#262262"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M191 5.57214V10.5554H184.694V5.57214H191ZM191 14.5872V39.458H184.694V14.5872H191Z",
    fill: "#262262"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M157.791 14.5872H150.713L140.732 25.1879V5.57214H134.88V39.458H140.732V32.1191L144.362 28.359L152.074 39.458H158.879L148.354 24.2366L157.791 14.5872Z",
    fill: "#262262"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0L8.43848 16.8977L27.0394 25.3238L15.1983 0H0Z",
    fill: "#00A79D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8352 0L27.0394 25.3238L54.0335 0H38.8352Z",
    fill: "#D7225D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0335 0L27.0394 25.3238L8.43848 16.8977L27.0394 54L54.0335 0Z",
    fill: "#262262"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLogin);
export default __webpack_public_path__ + "static/media/logo_login.daeddf6db5d02e25afb2d278a6e747cf.svg";
export { ForwardRef as ReactComponent };